import React from 'react'
import { connect } from 'react-redux'

import { Link} from "react-router-dom"
import './authenticate.css'
import axios from 'axios'
import {userList} from '../../redux/chatuser.redux.js'
import {authenticationFn} from '../../redux/chatuser.redux.js'
import {authenMsg} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'
import ToastBar from '../../component/toast/toast.js'
import AuthenticationAlert from '../../component/return-get-alert/authentication-alert.js'
import AuthenticationAlert7910 from '../../component/return-get-alert/authentication-alert-7910.js'
import AuthenticationAlert78 from '../../component/return-get-alert/authentication-alert-78.js'

@withRouter
@connect(
  state=>state.chatuser,
  {userList,authenticationFn,authenMsg}
)
class Authenticate extends React.Component{
	constructor(props){
		super(props)
		this.state={
			authenticationVla:'',
			authenticationData:Object,
			authenticationType:1,
			wechatNum:'点击查看',
			wechatImg:'',
			noticeMsg:{data1:'回归福利，心享俱乐部专享',data2:'特权礼包开放领取中'},
			gameInfo:'',
			showCode:false,
			gameOften:false,
			authenticationRoleOnOff:false

    	}
    	this.onOff = true
	}
	componentDidMount(){
		if(this.props.match.params.id){
			this.setState({
				noticeMsg:{data1:'',data2:''},
			})
		}
  		if(this.props.authenMsgData){
  			var idata =''
  			if(this.props.authenMsgData.account&&!this.props.authenMsgData.t_account){
				idata = this.props.authenMsgData.account
			}else{
				idata = this.props.authenMsgData.t_account
			}
			this.setState({
				authenticationVla:idata
			},function (argument) {

				this.handleAuthentication()
			})
			
  		}
		
  	}
  	componentWillReceiveProps(nextProps){
  		
  		if(this.props.userlist!==nextProps.userlist){
  			
  			if(nextProps.userlist.displayAccount){
				
				this.authenticationdata()
			}
  		}
		  	
  		this.setState({
  			gameInfo:nextProps.gameInfo
  		})
  		
  	
  	
  	}
  	authenticationdata(){
  		var oTime = parseInt(new Date().getTime()/1000)
  		axios.get('/fapi/recom/authToken?time='+oTime+'&account='+this.state.authenticationVla)
  			.then(res=>{
  				
  				if(res.data.return_code===0){
  					axios.get('/fapi/recom/authentication?token='+res.data.data.token+'&account='+this.state.authenticationVla)
		  			.then(res=>{
		  				

		  				if(res.data.return_code===0){

							var idata = res.data.data
							if(idata.game_often[0].game_id==='99999961'||idata.game_often[0].game_id==='9999960'||idata.game_often.length===0){
								
								this.setState({
									gameOften:true
								})
		  					}else{
		  						this.setState({
									gameOften:false
								})
		  					}
		  					this.setState({
		  						authenticationType:3,
		  						authenticationData:res.data.data,
		  						noticeMsg:{data1:'鉴定成功 欢迎回归',data2:'恭喜激活心享俱乐部回归特权'}
		  					})
							
		  					
		  					if(this.props.userlist.displayAccount){this.getManagerInfo()}
		  					this.props.authenticationDataFn&&this.props.authenticationDataFn(res.data.data)
		  					this.props.authenticationFn('3')

		  					this.props.propsAuthenticationData&&this.props.propsAuthenticationData(res.data.data)
		  				}else{
							if(res.data.return_code===-1001901){
								alert('鉴定账号过于频繁，请稍后尝试')
		  						return
		  					}
		  					if(res.data.return_code===-1001900){
		  						alert('鉴定账号异常，请联系客服')
		  						return
		  					}
		  					this.setState({ 
		  						authenticationType:2,
		  						authenticationData:res.data.data,
		  						noticeMsg:{data1:'很遗憾 鉴定失败',data2:'您未激活心享俱乐部回归特权'}
		  					})
		  					this.props.authenticationFn('2')
		  					this.props.propsAuthenticationData&&this.props.propsAuthenticationData(res.data.data)
		  				}
					
		  				//this.props.authenticationFn(this.state.authenticationVla)
						this.props.handleVla&&this.props.handleVla(this.state.authenticationData)
		  				
		  				})
  				}
  				
  			})
  		
  		 
  	}
  	handleAuthentication(){
  		
  		if(this.state.authenticationVla){
  			if(this.state.authenticationVla.indexOf('<')>=0||this.state.authenticationVla.indexOf('>')>=0){
	  			alert('非法输入')
	  			return
  			}
  		}
  		
  		if(this.props.userlist.code===-1){
  			var str = ''
  			if(this.props.match.params.id){
  				str = ''
  			}else{
  				str = '回归福利，心享俱乐部专享'
  			}
  			this.setState({
  				noticeMsg:{data1:str,data2:'特权礼包开放领取中'}
  			})
  			
  		}

  	
  		if(this.state.authenticationVla===''||!this.state.authenticationVla){return}
  		this.authenticationdata()
  		
  	} 
  	handleChange(e){
  		
  		this.setState({
  			authenticationVla:e.target.value
  		})

		
  	}
  	HandleSwitch(){
  		
  		if(this.props.userlist.code===-1){
  			var str = ''
  			this.props.propsAuthenticationData&&this.props.propsAuthenticationData('')
	  		this.props.handleVla&&this.props.handleVla('')
	  		this.props.authenMsg('')
  			
  			this.props.location.state = ''
  			
  			
			this.props.authenticationFn('1')
			
  			if(this.props.match.params.id){
  				str = ''
  			}else{
  				str = '回归福利，心享俱乐部专享'
  			}
  			this.setState({
  				authenticationType:1,
  				authenticationVla:'',
  				noticeMsg:{data1:str,data2:'特权礼包开放领取中'}
  			})
  			
  			this.props.location.state = ''
  		}else{

  			const MyOrigin = window.location.origin
			this.pathname = MyOrigin +''+ this.props.location.pathname
			
			
			window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
  		}
  		
  	}
  	handleAccount(){
		this.props.authenticationFn('')
		this.props.authenMsg('')
		this.props.handleVla&&this.props.handleVla('')
  		if(this.props.userlist.code===-1){
  			var str = ''
  			if(this.props.match.params.id){
  				str = ''
  			}else{
  				str = '回归福利，心享俱乐部专享'
  			}
  			this.setState({
  				authenticationType:1,
  				authenticationVla:'',
  				noticeMsg:{data1:str,data2:'特权礼包开放领取中'}
  			})
  			
  			
  			
  		}else{
  			const MyOrigin = window.location.origin
			this.pathname = MyOrigin +''+ this.props.location.pathname						
			window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
			return
  		}
  		this.props.authenticationFn('1')
  		this.props.propsAuthenticationData&&this.props.propsAuthenticationData('')
  	}
  	handleLogin(e){
  		if(this.props.userlist.displayAccount){
			this.setState({
				showCode:true
			})
			e.stopPropagation()
			return
  		}		
		const pathname = this.props.location.pathname
		axios.get('/fapi/getLoginURL?redirect_url='+window.location.href)
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		window.location.href = res.data.redirect_url
	 
	       	}
					     
		 })		
			
	}
	hideWhatCode(){
		
		this.setState({
			showCode:false
		})
	}
  	getManagerInfo(){
  	
  		axios.get('/fapi/recom/getManagerInfo?account='+this.state.authenticationVla)
  			.then(res=>{
  				
  				if(res.data.return_code===0){
  					if(res.data.data.manager){
  						this.setState({
		  					wechatNum:res.data.data.manager.wechatID,
		  					wechatImg:res.data.data.manager.qrcode_img
  						})
  					}
  					
  				}
  				
  				
  				
  		})
  	}
  	handleGameOften(item){
  		this.props.authenMsg(this.state.authenticationData)
  		this.props.history.push('/return-detail/'+item.game_id)
  		//this.props.handleVla(this.state.authenticationData)
  		
  	}
  	handleNoGameOften(){
  		const iPath= this.props.location.pathname
  		
  		if(iPath==='/return-m'){
			window.scrollTo(0,1000)
  		}else{
  			 this.props.history.push('/return-m')
  			 this.props.authenMsg(this.state.authenticationData)
  		}
  	}
  	checkAuthenticationRole(){
		this.setState({
			authenticationRoleOnOff:true
		})
  	}
  	ToastBarClose(){
  		this.setState({
  			authenticationRoleOnOff:false
  			
  		})
  	}
  	render(){
  			
  		return (

			<div className="authenticate-bar" onClick={()=>this.hideWhatCode()}>
				<div className="authenticate-notice">
					<span 
						className={this.state.gameInfo?'noticeMsg2':''} 
						style={!this.state.noticeMsg.data1||!this.props.match.params.id?
							{fontSize:'.42rem',top:!this.props.match.params.id?'-.5rem':'0rem'}:
							{fontSize:'.3rem',top:'-.2rem'}}
					>
						{
							this.state.gameInfo?
								this.props.gameInfo.gamename+'回归特权':
								this.state.noticeMsg.data1
						}
				  </span>
					<span className={this.state.gameInfo?'noticeMsg3':''}>{this.state.gameInfo?this.state.noticeMsg.data1:this.state.noticeMsg.data2}</span>
					<div 
						className="check-authentication-role"
						onClick={()=>this.checkAuthenticationRole()}
					>点击查看鉴定规则</div>
				</div>
				{
					this.state.authenticationType===1?<div className="authenticate-type1">
						<input type="text" placeholder="请输入通行证账号" onChange={(e)=>{this.handleChange(e)}}/>
						<button onClick={()=>this.handleAuthentication()}>立即鉴定领取回归特权</button>
					</div>:null
				}
				
				{
					this.state.authenticationType===2?<div className="authenticate-type2">
						<div className="jdsb">
							<i></i>
							<strong>
								{
									this.props.userlist.code===-1?
										this.state.authenticationData.t_account:
										this.state.authenticationData.account
								}	
							</strong>
							<span></span>
							<button onClick={()=>this.handleAccount()}>切换账号 重新鉴定</button>
						</div>
					</div>:null
				}

				{
					this.state.authenticationType===3?<div className="authenticate-type3 clearfix">
						<div className="left"></div>
						<div className="right">

							<div className="authenticate-role">
								<span>
									{
										this.props.userlist.code===-1?
											this.state.authenticationData.t_account:
											this.state.authenticationData.account
									}
								</span>
								<i></i>
							</div>
							<div>心享俱乐部等级：<span>{this.state.authenticationData.level}</span></div>
							{
								!this.state.gameOften&&<div>曾经玩过的游戏：
									{
										this.state.authenticationData.game_often.map((item,i)=>(

											<span 
												key={i} 
												className="changwan-span"
												onClick={()=>this.handleGameOften(item)}
											>{item.game_name}</span>
										))
									}
							
								</div>
							}
							{
								this.state.gameOften&&<div className="no-game-often" onClick={()=>this.handleNoGameOften()}>还未玩过盛趣游戏，点击查看游戏列表</div>
							}
							{
								this.state.authenticationData.exsit_manager===1||this.state.wechatNum!==''?
								<div className="er-code-ifo">客服经理微信号：<span onClick={(e)=>this.handleLogin(e)}>{this.state.wechatNum}</span>
								{this.state.wechatImg&&<em onClick={(e)=>this.handleLogin(e)}></em>}</div>:null
							}
							{this.state.showCode&&<div className="wechat-img" ><img src={this.state.wechatImg} /></div>}
						</div>
						<button onClick={()=>this.HandleSwitch()}>切换账号</button>
					</div>:null
				}
				{	this.state.showCode&&<div className="return-manger-mask"></div>	}
				
				{
					
						this.state.authenticationRoleOnOff&&<ToastBar visible={this.state.authenticationRoleOnOff} 
							title={'账号鉴定规则'}  
							isOkShow ={false} 
							iTop={'600px'}
							ToastBarClose={()=>this.ToastBarClose()}
							
						>	
							{this.props.match.params.id==='89'?<AuthenticationAlert></AuthenticationAlert>:''}
							{this.props.match.params.id==='78'?<AuthenticationAlert78></AuthenticationAlert78>:''}
							{this.props.match.params.id==='791000306'?<AuthenticationAlert7910></AuthenticationAlert7910>:''}
					</ToastBar>
				}
			</div>
  		)
  	}
}

export default Authenticate




// WEBPACK FOOTER //
// ./src/component/authenticate/authenticate.js